import { render, staticRenderFns } from "./Select-Customer.vue?vue&type=template&id=62a1a7e7&"
import script from "./Select-Customer.vue?vue&type=script&lang=js&"
export * from "./Select-Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports